import React from 'react';
import { useState, useEffect } from 'react';
import { TitleRow, ContainerRow } from '../styledComponents';
import CustomTypography from '../../CustomComponents/CustomTypography';
import { useSelector } from 'react-redux';
import SmallCard from '../../CustomComponents/SmallCard';
import { Col, Row, Modal, notification } from 'antd';
import { ClearOutlined } from '@ant-design/icons';

import { Link } from 'react-router-dom';
import PageTitle from '../../../Utils/PageTitle';
import { settingsContents } from './SettingsConfig';
import FacilityIcon from '../../../Assets/Icons/FacilityIcon';

const ClearFiltersIcon = ({ color }) => (
  <ClearOutlined style={{ fontSize: 28, color }} />
);

const Settings = () => {
  const [theme] = useSelector(state => [state.themeReducer]);
  const [user] = useSelector(state => [state.userReducer]);
  const [settingsItems, setSettingsItems] = useState([]);
  const [clearModalVisible, setClearModalVisible] = useState(false);

  useEffect(() => {
    if (user) setSettingsItems(settingsContents(user.userType));
    // eslint-disable-next-line
  }, [user]);

  const handleClearFilters = () => {
    sessionStorage.clear();
    setClearModalVisible(false);
    notification.success({
      message: 'Filters Cleared',
      description: 'All saved filters have been cleared.'
    });
  };

  return (
    <>
      <PageTitle title='Settings' />
      <ContainerRow gutter={[0, 40]}>
        <TitleRow span={24}>
          <CustomTypography color={theme['@text-color']}>
            Settings
          </CustomTypography>
        </TitleRow>

        <Modal
          title='Clear All Filters'
          visible={clearModalVisible}
          onOk={handleClearFilters}
          onCancel={() => setClearModalVisible(false)}
          okText='Clear'
          okButtonProps={{ danger: true }}
          cancelText='Cancel'
        >
          <p>Are you sure you want to clear all saved filters? This will reset filters across all pages for your current session.</p>
        </Modal>

        <Col span={24}>
          <Row gutter={[36, 36]}>
            {settingsItems.map(item => (
              <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={3} style={{ display: 'flex' }}>
                <Link to={item.path} style={{ width: '100%' }}>
                  <SmallCard item={item} />
                </Link>
              </Col>
            ))}
            {
              (user.userType === 'admin' && user.facilityAccessEnable) ?
                <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={3} style={{ display: 'flex' }}>
                  <Link to={'/dashboard/settings/facility'} style={{ width: '100%' }}>
                    <SmallCard item={{
                      title: 'Facility',
                      background: '#c2ffcf',
                      iconColor: '#4d8759',
                      icon: FacilityIcon,
                      path: '/dashboard/settings/facility'
                    }} />
                  </Link>
                </Col>
                :
                null
            }
            {/* <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={3}>
              <div
                onClick={() => setClearModalVisible(true)}
                style={{ cursor: 'pointer', color: theme['@primary-color'] }}
              >
                <SmallCard item={{
                  title: 'Clear All Filters',
                  background: '#ffe4e4',
                  iconColor: '#d9363e',
                  icon: ClearFiltersIcon
                }} />
              </div>
            </Col> */}
          </Row>
        </Col>
      </ContainerRow>
    </>
  );
};
export default Settings;
